import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
import { UseCaseState } from '../models/flow.model';

@Injectable({ providedIn: 'root' })
export class StateUseCaseService {
	private _useCase$ = new BehaviorSubject<UseCaseState | null>(null);

	constructor() {}

	get useCase$() {
		return this._useCase$.asObservable();
	}

	get useCase() {
		return this._useCase$.value;
	}

	save(state: UseCaseState) {
		this._useCase$.next(state);
	}

	destroy() {
		this._useCase$.next(null);
	}
}
